"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = require("../../tokens");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const SPACE_AROUND_BULLET = '0.5em';
const StyledBulletSeparator = _styledComponents.default.div.withConfig({
  displayName: "StyledBulletSeparator",
  componentId: "sc-rhbcl2-0"
})(["& > *:not(:last-child){margin-right:", ";}& > * + *{position:relative;margin-left:", ";&:before{content:'';border-radius:50%;display:inline-block;position:relative;left:-", ";top:-1px;vertical-align:middle;", ";background:", ";}}"], SPACE_AROUND_BULLET, SPACE_AROUND_BULLET, SPACE_AROUND_BULLET, _ref => {
  let {
    bulletSize
  } = _ref;
  return `
        width: ${bulletSize};
        height: ${bulletSize};
      `;
}, _ref2 => {
  let {
    bulletColor
  } = _ref2;
  return bulletColor;
});

/**
## Usage

```js
import { BulletSeparator } from '@farewill/ui'
```
 */
const BulletSeparator = _ref3 => {
  let {
    children = null,
    bulletColor = _tokens.COLOR.GREY.LIGHT,
    bulletSize = '5px',
    ...props
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(StyledBulletSeparator, _extends({
    bulletColor: bulletColor,
    bulletSize: bulletSize
  }, props), children);
};
var _default = exports.default = BulletSeparator;